module.exports = __webpack_public_path__ + "static/media/skepastaries.8f541b57.jpg";